export enum createCompanyFormFields {
  crNumber = 'crNumber',
  crExpDate = 'crExpDate',
  owner = 'owner',
  phoneNumber = 'phoneNumber',
  email = 'email',
  name = 'name',
  nameAr = 'nameAr',
  vatNumber = 'vatNumber',
}

export interface DocumentFileFileds {
  file: File;
  companyId: string;
  documentTypeId: string;
}
